module.exports = __webpack_public_path__ + "static/media/logo.e640a2d6.gif";